import {
  Injectable,
} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RedirectCommand,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {
  getElementFromSessionStorage,
  isCurrentSessionValid,
  popElementFromSessionStorage,
  SessionStorageData,
  setElementInSessionStorage,
} from '@refx/shared-common';
import {
  BookingRoutes,
} from '../configuration/routes';

@Injectable()
export class AppGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  /**
   * Set the current entry point and start over the flow if the session is not valid
   *
   * @param route
   * @param state
   */
  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): true | RedirectCommand {
    const navigation = this.router.getCurrentNavigation();
    const isLateLoginFlow = popElementFromSessionStorage(SessionStorageData.optedForLateLogin);
    const isModifyFlight = popElementFromSessionStorage(SessionStorageData.optedForModifyFlight);
    const isPlusgradeRedirection = getElementFromSessionStorage(SessionStorageData.optedForPlusgradeRedirection);
    const isRedirectedFromHopper = popElementFromSessionStorage(SessionStorageData.isRedirectedFromHopper);

    // Store the URL if it is an entry point
    if (route.firstChild && route.firstChild.data.entryPoint) {
      setElementInSessionStorage(SessionStorageData.entryPointURL, state.url);
      // Start over the flow if the session is not valid
    } else if (
      !isCurrentSessionValid()
      && !(isLateLoginFlow || isModifyFlight || isPlusgradeRedirection || isRedirectedFromHopper)
      && !(navigation && navigation.extras.state && navigation.extras.state.isSessionValid)
    ) {
      const entryPoint = getElementFromSessionStorage(SessionStorageData.entryPointURL);
      return new RedirectCommand(this.router.parseUrl(entryPoint || BookingRoutes.recovery), {
        replaceUrl: false
      });
    }
    return true;
  }
}
